"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Mocha = void 0;
var Mocha;
(function (Mocha) {
    Mocha["InvalidArgType"] = "ERR_MOCHA_INVALID_ARG_TYPE";
    Mocha["InvalidArgValue"] = "ERR_MOCHA_INVALID_ARG_VALUE";
    Mocha["InvalidException"] = "ERR_MOCHA_INVALID_EXCEPTION";
    Mocha["InvalidInterface"] = "ERR_MOCHA_INVALID_INTERFACE";
    Mocha["InvalidReporter"] = "ERR_MOCHA_INVALID_REPORTER";
    Mocha["NoFilesMatchPattern"] = "ERR_MOCHA_NO_FILES_MATCH_PATTERN";
    Mocha["Unsupported"] = "ERR_MOCHA_UNSUPPORTED";
})(Mocha = exports.Mocha || (exports.Mocha = {}));
//# sourceMappingURL=mocha.js.map